// extracted by mini-css-extract-plugin
module.exports = {"nounInfoHeader":"NounInfoCard_nounInfoHeader__r6K6B","nounInfoRow":"NounInfoCard_nounInfoRow__1iqd0","nounInfoRowText":"NounInfoCard_nounInfoRowText__tGZn_"};